import React from "react";

const PrivacyPolicy = () => {
    return (
        <div className="text-[#01184D] bg-white my-8 mx-16">
            <p>Rising Sun Judo Club ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal information when you use our website (<a href="https://www.rsjc.co.uk/">https://www.rsjc.co.uk/</a>).</p>

            <h2 className="font-bold">1. Information We Collect</h2>
            <p>When you submit a message through our website contact form, we collect the following personal information:</p>
            <br /><ul>
                <li>First and last name</li>
                <li>Email address</li>
                <li>Phone number</li>
            </ul>          <br />
            <br />
            <h2 className="font-bold">2. How We Collect Information</h2>
            <p>We collect personal information solely through our website's contact form. We do not use cookies, tracking technologies, or other registration methods.</p>
            <br />
            <h2 className="font-bold">3. Purpose of Data Collection</h2>
            <p>We use the collected information solely to respond to your message and inquiries submitted through our website.</p>
            <br />
            <h2 className="font-bold">4. Data Sharing and Disclosure</h2>
            <p>We do not share your personal data with third parties. However, if required by law enforcement or official authorities (such as the police), we may disclose personal information as required.</p>
            <br />
            <h2 className="font-bold">5. Data Protection</h2>
            <p>We store collected personal information in a password-protected account to prevent unauthorized access.</p>
            <br />
            <h2 className="font-bold">6. Data Retention</h2>
            <p>We retain collected personal information only for as long as necessary to fulfill its intended purpose. Once we have responded to your inquiry, the data will be securely deleted.</p>
            <br />
            <h2 className="font-bold">7. User Rights</h2>
            <p>You have the right to:</p>
            <br /> <ul>
                <li>Request access to the personal data we hold about you</li>
                <li>Request correction of any incorrect information</li>
                <li>Request deletion of your personal data</li>
            </ul>          <br />
            <p>To exercise these rights, please contact us using the details provided below.</p>
            <br />
            <h2 className="font-bold">8. How to Contact Us</h2>
            <p>If you have any questions or concerns regarding this Privacy Policy or your personal information, you can contact us through:</p>
            <br />  <ul>
                <li><strong>Email:</strong> <a href="mailto:risingsunjudoclub@gmail.com">risingsunjudoclub@gmail.com</a></li>
                <li><strong>Phone:</strong> 07711 164168</li>
                <li><strong>Contact Form:</strong> <a href="https://www.rsjc.co.uk/contact-us">https://www.rsjc.co.uk/contact-us</a></li>
            </ul>          <br />
            <br />
            <h2 className="font-bold">9. Privacy Policy Updates</h2>
            <p>We may update this Privacy Policy from time to time. Any changes will be posted on our website, and we encourage you to review this page periodically to stay informed.</p>
            <br />
            <p>By using our website, you agree to the terms of this Privacy Policy.</p>
        </div>
    )
}

export default PrivacyPolicy;